import React,{ useMemo } from 'react';
import { useTable, useSortBy } from 'react-table';

import { OverlayTrigger, Tooltip } from 'react-bootstrap';
//import './table.css';

export const SortingTable = ({column,rowsArr,handleVerify}) => {
	
	const columns = useMemo( () => column, [] )
	const data = useMemo( () => rowsArr, [rowsArr] )
	
	const tableInstance = useTable({columns,data},
		useSortBy
	)
	
	const { 
		getTableProps, 
		getTableBodyProps, 
		headerGroups,
		//footerGroups,
		rows, 
		prepareRow,
	} = tableInstance
	
	return(
		<>	
			<div className="card">
				<div className="card-header">
					<h3 >Invoice Verification</h3>
				</div>
				<div className="card-body">
					<div className="table-responsive">
						<div className="dataTables_wrapper">
							<table {...getTableProps()} className="table dataTable display">
								<thead >
								   {headerGroups.map(headerGroup => (
										<tr {...headerGroup.getHeaderGroupProps()}>
											{headerGroup.headers.map(column => (
												<th {...column.getHeaderProps(column.getSortByToggleProps())} style={{ color: "rgba(23, 90, 169, 0.78)" }}>
													{column.render('Header')}
													<span className="ml-1">
														{column.isSorted ? (
															column.isSortedDesc ?  
																<i className="fa fa-arrow-down ms-2 fs-14"  style={{opacity: '0.7'}} />
																	:  
																<i className="fa fa-arrow-up ms-2 fs-14" style={{opacity: '0.7'}} /> 
															) 
																: 
															(<i className="fa fa-sort ms-2 fs-14"  style={{opacity: '0.3'}} />) 
														}
													</span>
												</th>
											))}
										</tr>
								   ))}
								</thead> 
								{/* <tbody {...getTableBodyProps()}>
								
									{rows.map((row) => {
										prepareRow(row)
										return(
											<tr {...row.getRowProps()}>
												{row.cells.map((cell) => {
													return <td {...cell.getCellProps()}> {cell.render('Cell')} </td>
												})}
												
											</tr>
										)
									})}
								</tbody> */}

<tbody {...getTableBodyProps()}>
    {rows.map((row, rowIndex) => {
        prepareRow(row)
        return (
            <tr {...row.getRowProps()} >
                {row.cells.map((cell, cellIndex) => {
			
                    const isLastColumn = cellIndex === row.cells.length - 1;

                    return (
                        <td {...cell.getCellProps()} style={{color:'black'}}>
								
                            {isLastColumn ? (

								
                                <div>
                                    <OverlayTrigger
                          placement="top"
                          overlay={<Tooltip id="tooltip">{"verify"}</Tooltip>}
                        >
                          <i
                            className="material-icons"
                            style={{
                              color: "rgba(23, 90, 169, 0.78)",
                              marginRight: "6px",
                              cursor: "pointer",
                            }}
                            onClick={() => {
								handleVerify(rows[rowIndex].original.Id);
                            }}
                          >
                            domain_verification
                          </i>
                        </OverlayTrigger>
                        <OverlayTrigger
                          placement="top"
                          overlay={<Tooltip id="tooltip">{"veiw"}</Tooltip>}
                        >
                          <i
                            className="material-icons"
                            style={{
                              color: "rgba(23, 90, 169, 0.78)",
                              marginRight: "6px",
                              cursor: "pointer",
                            }}
                          >
                            visibility
                          </i>
                        </OverlayTrigger>
                        <OverlayTrigger
                          placement="top"
                          overlay={<Tooltip id="tooltip">{"delete"}</Tooltip>}
                        >
                          <i
                            className="material-icons"
                            style={{
                              color: "red",
                              marginRight: "6px",
                              cursor: "pointer",
                            }}
                          >
                            delete
                          </i>
                        </OverlayTrigger>
                                </div>
                            ) : (
                                cell.render('Cell')
                            )}
                        </td>
                    );
                })}
            </tr>
        );
    })}
</tbody>
								{/* This is only for footer if u require */}
								 
							</table>
						</div>
					</div>
				</div>
			</div>
		</>
	)
	
}
export default SortingTable;